export default "__VITE_ASSET__B38o2CF1__"